module.exports = __webpack_public_path__ + "img/softwar_actionstep.5446d685.jpg";